import React from 'react';
import { motion } from 'framer-motion'; // Import Framer Motion
import logo from "../assets/images/logo.jpg";
import Photo from "../assets/images/background.jpg";
function Home() {
    return (
        <div className='w-full min-h-screen flex flex-col items-center justify-start bg-gray-100 p-6 overflow-y-auto'>
            {/* Welcome Message */}
            <div className='w-full  mb-8 relative overflow-hidden z-0 flex flex-col justify-center items-center'>
                {/* Blurred Background Image */}

                <motion.h2
                    className="w-full top-[2px]  text-center text-2xl font-bold text-[#000] mb-4 justify-center items-center"
                    initial={{ x: "-100vw", opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ type: "spring", stiffness: 50, damping: 15 }}
                >
                    Welcome to Arya Senior College, Manjari
                    
                </motion.h2>


                <img src={Photo} alt='' className='w-[400px] h-[300px] ' />



            </div>


            {/* College Info Box */}
            <div className='bg-white shadow-lg rounded-2xl p-6 max-w-md text-center border-[#891838] border'>
                <p>Greenworld Foundation's</p>
                <h5 className='text-xl font-bold text-gray-700 mb-2'>Arya Senior College,Manjari</h5>
                <p className='text-gray-700'>At/Post: Manjari, Tal: Rahuri, Dist: Ahilyanagar,</p>
                <p className='text-gray-700'>State: Maharashtra, India, Pin Code: 413705</p>
                <p className='text-gray-700 mt-4'>
                    Contact No:
                    <a href='tel:+919822350535' className='text-blue-500 font-medium'> +91 98223 50535</a>
                </p>
                <p className='text-gray-700'>
                    Mail Id:
                    <a href='mailto:aryasenior23@gmail.com' className='text-blue-500 font-medium'> aryasenior23@gmail.com</a>
                </p>
                <a href="https://bcud.unipune.ac.in/utilities/college_search/CAAA021740_ENG/Pune_University_College"
                    className='text-green-600 font-semibold mt-4 no-underline'>SAVITRIBAI PHULE PUNE UNIVERSITY APPROVED</a>
            </div>

            {/* Footer */}
            <footer className='w-full py-4 mt-8 bg-[#891838] text-white text-center text-sm'>
                <p>© {new Date().getFullYear()} Arya Senior College. All rights reserved.</p>
            </footer>
        </div>
    );
}

export default Home;
